import request from '../utils/request.js'
export const list_tag=(imei,phone)=>{
    return request({
        url:'/client/list_tag',
        method:'post',
        data:{
			imei,
			phone
        }
    })
}
export const upload_tag=(data,imei,predate,phone)=>{
    return request({
        url:'/client/upload_tag',
        method:'post',
        data:{
            data,
			imei,
			predate,
			phone
        }
    })
}
export const data_tag=(imei,predate=0)=>{
    return request({
        url:'/client/data_tag',
        method:'post',
        data:{
            imei,
			predate
        }
    })
}
export const data_day=(phone)=>{
    return request({
        url:'/client/data_day',
        method:'post',
        data:{
            phone
        }
    })
}
export const choice_day_data=(phone,time)=>{
    return request({
        url:'/client/day_report',
        method:'post',
        data:{
            phone,
            time
        }
    })
}
export const data_week=()=>{
    return request({
        url:'/client/data_week',
        method:'post'
    })
}
export const choice_week_data=(phone,startTime,endTime,preStartTime,preEndTime)=>{
    return request({
        url:'/client/week_report',
        method:'post',
        data:{
            phone,
            startTime,
            endTime,
            preStartTime,
            preEndTime,
        }
    })
}
export const data_month=()=>{
    return request({
        url:'/client/data_month',
        method:'post'
    })
}
export const choice_month_data=(phone,startTime,endTime,preStartTime,preEndTime)=>{
    return request({
        url:'/client/month_report',
        method:'post',
        data:{
            phone,
            startTime,
            endTime,
            preStartTime,
            preEndTime,
        }
    })
}
export const user_info=(phone)=>{
    return request({
        url:'/client/user_info',
        method:'post',
        data:{
            phone
        }
    })
}
export const update_userinfo=(phone,nickname,gender,birthday)=>{
    return request({
        url:'/client/update_userinfo',
        method:'post',
        data:{
            phone,
            nickname,
            gender,
            birthday
        }
    })
}
export const health_data=(imei)=>{
    return request({
        url:'/client/health_data',
        method:'post',
        data:{
            imei
        }
    })
}
export const beatHeart_data=(imei)=>{
    return request({
        url:'/client/beatHeart_data',
        method:'post',
        data:{
            imei
        }
    })
}
export const bind_imei=(phone,imei)=>{
    return request({
        url:'/client/bind_imei',
        method:'post',
        data:{
            phone,
            imei
        }
    })
}
export const unbind_imei=(phone,imei)=>{
    return request({
        url:'/client/unbind_imei',
        method:'post',
        data:{
            phone,
            imei
        }
    })
}
export const add_feedback=(imei,phone,type,content,pic,upload_time)=>{
    return request({
        url:'/client/add_feedback',
        method:'post',
        data:{
            imei,
            phone,
            type,
            content,
            pic,
            upload_time,
        }
    })
}
export const feedback_record=(imei)=>{
    return request({
        url:'/client/feedback_record',
        method:'post',
        data:{
            imei
        }
    })
}
export const multer_pic=(data)=>{
    return request({
        url:'/client/multer_pic',
        method:'post',
        data:data
    })
}
export const feedback_details=(id)=>{
    return request({
        url:'/client/feedback_details',
        method:'post',
        data:{
            id
        }
    })
}